// in src/NotFound.js
import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

export default () => (
    <Card>
        <CardContent>
            <h1>404: Not found</h1>
        </CardContent>
    </Card>
);